<div class="selection-buttons-container">
  <div class="selection-buttons-title" [innerHTML]="title"></div>
  <div class="selection-buttons-options">
    <div *ngFor="let button of buttonsArray">
      <app-selection-button [buttonInfoBehaviorSubject]="button" (buttonOnClick)="onSelection($event)">
      </app-selection-button>
    </div>
  </div>
</div>
